import { baseUrl } from "./constants";
import { fetchWrapper } from "./fetchwrapper";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationDE from "../locale/de/translation.json";
import translationEN from "../locale/en/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
};
//abfrage ob ein touch device verwendet wird
export function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
// initialize i18next with catalog and language to use
i18n.use(LanguageDetector).init({
  resources,
});

export const helperMethods = {
  nachkomma,
  convertToNumber,
  downloadFile,
  addAccessedModuleCountValue,
};

function nachkomma(val: any, pos: number) {
  if (val == null) {
    return 0;
  }

  if (typeof val == "string") {
    val = convertToNumber(val);
  }

  if (!isNaN(Number(val))) {
    return val.toLocaleString(undefined, { maximumFractionDigits: pos });
  } else {
    return 0;
  }
}

function addAccessedModuleCountValue(module: string) {
  fetchWrapper
    .get(baseUrl + "/api/Kpi/AddAccessedModuleCountValue?module=" + module)
    .then((result) => {});
}

const parseLocalizedNumber = (input: string): number => {
  var locale = i18n.language.includes("de") ? "de" : "en";
  if (typeof input !== "string") return NaN;

  let normalized = input.trim();

  if (locale == "de") {
    normalized = normalized.replace(/\./g, "").replace(",", ".");
  } else {
    normalized = normalized.replace(/,/g, "");
  }

  const result = Number(normalized);
  return isNaN(result) ? NaN : result;
};

function convertToNumber(input: any) {
  if (typeof input == "string") {
    input = parseLocalizedNumber(input);
    /* val = val == "" ? 0 : parseFloat(val.replace(",", ".").replace(" ", "")); */
  }
  return input;
}

function downloadFile(file: any, isAuthenticated: boolean) {
  let fileName = "";
  if (file.displayDocFileName) {
    fileName = file.displayDocFileName;
  } else if (file.docFileName && file.docFileExtension) {
    fileName = file.docFileName.replace(file.docFileExtension, "");
  } else if (file.benennungDE) {
    fileName = i18n.language.includes("de")
      ? file.benennungDE
      : file.benennungEN;
  } else if (file.description) {
    fileName = file.description;
  } else if (file.docTypeDE && file.docTypeEN) {
    fileName = i18n.language.includes("de") ? file.docTypeDE : file.docTypeEN;
  } else {
    fileName = "Download";
  }

  const ext = file.docFileExtension.replace(".", "");

  if (isAuthenticated) {
    return fetchWrapper
      .downloadFileWithAuth(
        baseUrl + "/api/documents/GetDocumentFromPath?path=" + file.docPath,
      )
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName.replace(".", "") + "." + ext);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);

        return true;
      });
  } else {
    return fetchWrapper
      .downloadFile(
        baseUrl + "/api/documents/GetDocumentFromPath?path=" + file.docPath,
      )
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName + "." + ext);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);

        return true;
      });
  }
}
